import { useEffect, useRef } from 'react'
import SendIcon from '../../../assets/svgs/Send'
import { useFilesContext } from '../../../contexts/FilesContext'
import { logEvent } from '../../../utils/logEvent'
import style from './ChatInput.module.css'

const ChatInput = ({
  handleResponses,
  setFormData,
  formData = { message: '' },
  errorMessage,
  setErrorMessage,
}) => {
  const inputRef = useRef(null)
  const { files, removeFile } = useFilesContext()

  useEffect(() => {
    if (errorMessage && inputRef.current) {
      inputRef.current.focus()
    }
  }, [errorMessage])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (errorMessage) setErrorMessage('')
    setFormData((prev) => ({ ...prev, [name]: value }))
    // Auto-grow up to 3 lines (~80px)
    e.target.style.height = 'auto'
    e.target.style.height = Math.min(e.target.scrollHeight, 80) + 'px'
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!errorMessage && formData.message) {
      logEvent({ action: 'message_chat', content: formData.message })
    }
    handleResponses(formData.message)
    setFormData({ message: '' })
    if (inputRef.current) inputRef.current.style.height = 'auto'
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  const CATEGORY_COLOR = {
    Jobs: '#7c4dff', Courses: '#00acc1', Events: '#2e7d32', News: '#ef6c00',
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>

      {/* Attachment pills — always visible when files are attached */}
      {files.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '0 2px' }}>
          {files.map(f => {
            const color = CATEGORY_COLOR[f.category] || '#432C5B'
            return (
              <div
                key={f.id}
                style={{
                  display: 'flex', alignItems: 'center', gap: 5,
                  background: `${color}18`,
                  border: `1px solid ${color}40`,
                  borderRadius: 20, padding: '4px 6px 4px 10px',
                  maxWidth: 200,
                }}
              >
                <span style={{
                  fontFamily: 'Poppins, sans-serif', fontSize: 11, fontWeight: 600,
                  color, flex: 1,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {f.title || f.category || 'Item'}
                </span>
                <button
                  type="button"
                  onClick={() => removeFile(f.id)}
                  title={`Remove "${f.title || 'item'}"`}
                  style={{
                    flexShrink: 0, background: 'none', border: 'none',
                    cursor: 'pointer', padding: 2, color: '#b0b2c0',
                    fontSize: 12, lineHeight: 1, display: 'flex', alignItems: 'center',
                  }}
                >
                  ✕
                </button>
              </div>
            )
          })}
        </div>
      )}

    <div className={style.chatBigInputContainer} style={{ position: 'relative' }}>
      <div
        className={`${style.chatInputWrapper} ${errorMessage ? style.chatInputWrapper_error : ''}`}
      >
        <textarea
          ref={inputRef}
          className={style.chatBiginput}
          placeholder="Ask Chimp  (Shift+Enter for new line)"
          value={formData.message || ''}
          name="message"
          rows={1}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          style={{ resize: 'none', overflow: 'hidden' }}
        />
      </div>

      <button className={style.send} onClick={handleSubmit}>
        <SendIcon />
      </button>
    </div>

    </div>
  )
}

export default ChatInput
